import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { CareerIcon } from 'atoms/CareerIcon/CareerIcon';
import { careerColor, careerTokenVars } from 'services/careerTokens';
import { careerLayout } from 'services/careerType';

interface ICareerCloseButton {
  onClick: () => void;
  /** Своё имя, если «Zamknij» мало (например, «Zamknij menu»). */
  label?: string;
}

/**
 * Крестик закрытия карьерных панелей и окон (ТЗ 0073, 5.2).
 *
 * 🔴 Встроенный крестик antd 5.4 у Modal и Drawer подписан «Close»
 * по-английски при любой локали, и заменить подпись пропом нельзя. Поэтому
 * окна раздела ставят `closable={false}` и этот крестик — в заголовок или
 * `extra`. Переменные цвета объявлены здесь: окна живут в портале.
 */
export const CareerCloseButton = memo(({ onClick, label }: ICareerCloseButton) => {
  const { t } = useTranslation();
  return (
    <Button type="button" aria-label={label || `${t('careerCenter.map.close')}`} onClick={onClick}>
      <CareerIcon name="close" size={20} />
    </Button>
  );
});

const Button = styled.button`
  ${careerTokenVars}
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${careerLayout.hitTarget}px;
  height: ${careerLayout.hitTarget}px;
  margin: -10px -12px -10px 0;
  padding: 0;
  border: 0;
  border-radius: ${careerLayout.controlRadius}px;
  background: transparent;
  color: ${careerColor.text};
  cursor: pointer;

  &:hover {
    background: ${careerColor.hover};
  }

  &:focus-visible {
    outline: 2px solid ${careerColor.text};
    outline-offset: 2px;
  }
`;
